import { useFocusGesture } from '../../gestures/use-focus-gesture.js';
import { useHoverGesture } from '../../gestures/use-hover-gesture.js';
import { useTapGesture } from '../../gestures/use-tap-gesture.js';
import { makeRenderlessComponent } from '../utils/make-renderless-component.js';
var gestureAnimations = {
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
};
export { gestureAnimations };